/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { WalletconnectModule } from "@vlinder-web/walletconnect-module-react";
import { transactionsDetails } from "./test-data/profile.detail";

import { REGISTER_WALLET } from "../pages/WalletScreen/graphql/wallet-registration.mutation";
import { GET_WALLET_BALANCE } from "../pages/WalletScreen/graphql/get-wallet-balance.query";
import { CREATE_TX } from "../pages/WalletScreen/graphql/createtx.balance.mutation";
import { CREATE_TX_RESELL } from "../pages/WalletScreen/graphql/createtx.resellbalance.mutation";
import { SEND_TX_RESULT } from "../pages/WalletScreen/graphql/sendtx-result.mutation";
import { GET_MY_WALLETS } from "../pages/WalletScreen/graphql/get-my-wallets.mutation"
import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import { getErrorMessage } from "../utils/error.message";

const is = require("is_js");

const MODULE_NAME = "MyWalletService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class MyWalletService {
    private static instance: MyWalletService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): MyWalletService {
        if (!MyWalletService.instance) {
            MyWalletService.instance = new MyWalletService(props);
        }
        return MyWalletService.instance;
    }

    async verifySignature(signature: any) {
        log.info(`verify signature`, signature);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: REGISTER_WALLET,
                    variables: {
                        signature: signature?.result,
                        expectedAddress: signature?.params[1],
                        message: "Please sign to prove your wallet address",
                    },
                });
                if (res?.data?.registerMyWallet) {
                    return res?.data?.registerMyWallet;
                }

            }
            // return true;
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async getWalletBalance(did: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_WALLET_BALANCE,
                    variables: {
                        did: did
                    },
                    fetchPolicy: 'network-only'
                });
                log.success(`wallet balance`, res);
                if (res?.data) {
                    return res?.data;
                }

            }
            // return true;
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async createWithdrawTx(signature: any) {
        log.info(`verify signature`, signature);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: CREATE_TX,
                    variables: {
                        auth: {
                            signature: signature?.result,
                            expected_address: signature?.params[1],
                            message: "Please sign to prove your wallet address",
                        }

                    },
                });
                if (res?.data?.withdrawForMinter) {
                    return res?.data?.withdrawForMinter?.transaction;
                }
            }
            // return true;
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async createResellWithdrawTx(signature: any) {
        log.info(`verify signature`, signature);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: CREATE_TX_RESELL,
                    variables: {
                        auth: {
                            signature: signature?.result,
                            expected_address: signature?.params[1],
                            message: "Please sign to prove your wallet address",
                        }

                    },
                });
                if (res?.data?.withdrawFormResellCredit) {
                    return res?.data?.withdrawFormResellCredit?.transaction;
                }
            }
            // return true;
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async sendTxResult(txData: any, signature: any) {
        log.info(`verify signature`, signature);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: SEND_TX_RESULT,
                    variables: {
                        auth: {
                            signature: signature?.result,
                            expected_address: signature?.params[1],
                            message: "Please sign to prove your wallet address",
                        },
                        input: {
                            hash: txData?.txHash
                        }
                    },
                });
                if (res?.data?.lockOnTxnSuccess) {
                    return res?.data?.lockOnTxnSuccess;
                }
            }
            // return true;
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async getMyWallets() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_MY_WALLETS,
                    fetchPolicy: 'network-only'
                });
                log.success(`my wallets`, res);
                if (res?.data) {
                    return res?.data?.getMyWallets;
                }
            }
            // return true;
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

}
